var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63431 0.234314C9.94673 -0.0781044 10.4533 -0.0781046 10.7657 0.234314C11.0781 0.546734 11.0781 1.05327 10.7657 1.36568L5.4217 6.70968C4.81646 7.31491 3.8352 7.315 3.22986 6.70987L0.234414 3.71548C-0.0780602 3.40311 -0.0781495 2.89658 0.234215 2.58411C0.54658 2.27163 1.05311 2.27154 1.36559 2.58391L4.32567 5.54296L9.63431 0.234314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.29c5adfc0448671016782c522bff0840.svg";
export { ForwardRef as ReactComponent };